import styled, { keyframes, css } from "styled-components";

const shake = keyframes`
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-4px); }
  40%, 80% { transform: translateX(4px); }
`;

export const Background = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  background: url("/login/background.png") center / cover no-repeat;
`;

export const FormLogin = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 70px;
  border-radius: 24px;

  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
`;

export const Logo = styled.img``;

export const Title = styled.label`
  font-size: 38px;
  padding-top: 30px;
  color: #ffffff;
`;

export const SubTitle = styled.label`
  font-size: 20px;
  color: #ffffff;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 350px;
  margin-top: 0;
  margin-bottom: 0;
  max-height: 0;
  opacity: 0;
  transition: all 0.4s ease;

  &.show {
    margin-top: 18px;
    margin-bottom: 18px;
    max-height: 80px; /* 충분히 큰 값 */
    opacity: 1;
  }
`;

export const InputBox = styled.input<{ $hasError?: boolean }>`
  width: 350px;
  height: 40px;
  padding: 8px;
  font-size: 16px;
  color: #ffffff;

  border: none;
  border-bottom: 2px solid ${({ $hasError }) => ($hasError ? "red" : "#ffffff")};
  background-color: transparent;
  outline: none;

  /* 포커스 시에도 배경 고정 */
  &:focus {
    background-color: transparent;
    outline: none;
  }

  /* 텍스트 선택 배경(원하면 투명/살짝 반투명으로) */
  &::selection {
    background: rgba(255, 255, 255, 0.18); /* 필요하면 transparent 로 */
  }

  /* 크롬/엣지 자동완성 배경 제거 */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    -webkit-text-fill-color: #ffffff;
    transition: background-color 99999s ease-out 0s;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    box-shadow: 0 0 0px 1000px transparent inset;
    background-color: transparent !important;
  }

  /* 파이어폭스 자동완성 */
  &:-moz-autofill {
    -moz-text-fill-color: #ffffff;
    box-shadow: 0 0 0 1000px transparent inset;
  }

  &:focus ~ label,
  &:not(:placeholder-shown) ~ label {
    top: -14px;
    font-size: 12px;
    color: ${({ $hasError }) => ($hasError ? "red" : "#00c6ff")};
  }
`;

export const FloatingLabel = styled.label<{ $hasError?: boolean }>`
  position: absolute;
  left: 5px;
  top: 8px;
  font-size: 16px;
  color: ${(props) => (props.hasError ? "red" : "#ccc")};
  pointer-events: none;
  transition: 0.2s ease all;

  ${({ $hasError }) =>
    $hasError &&
    css`
      animation: ${shake} 0.4s ease;
    `}
`;

export const ErrorMessage = styled.div<{ $visible?: boolean }>`
  color: red;
  padding-top: 10px;
  font-size: 18px;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.3s ease;
`;

export const Button = styled.button`
  width: 350px;
  height: 45px;
  margin-top: 30px;

  border: none;
  border-radius: 24px;
  color: white;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;

  background: linear-gradient(135deg, #00c6ff, #0072ff);
  box-shadow: 0 4px 12px rgba(0, 114, 255, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #0098ff, #005ce6);
    box-shadow: 0 6px 20px rgba(0, 114, 255, 0.4);
    transform: translateY(-2px);
  }

  &:active {
    transform: scale(0.98);
  }
`;
